import React, { useState, useEffect } from 'react';
import { SurveyLayout } from '../../../components/views/layouts/surveyLayout';
import { Box, Typography } from '@mui/material';
import { FormRender } from './formRender';
import { FormRenderTemporalPrevisora } from './temporalPrevisora/formRender';

const SurveysFormView = () => {
    const [save, setSave] = useState<boolean>(false);
    const [survey, setSurvey] = useState<any>(undefined);
    const isPrevisora = survey?.code === '05_05_26_Temporal_Previsora';
    const dominantColor = isPrevisora
        ? '#800080'
        : (survey?.themeColor || survey?.projectIds?.[0]?.color || '#3D91FF');
    const fontFamily = isPrevisora ? undefined : survey?.fontFamily;

    useEffect(() => {
        const METRO_MEDELLIN_PROJECT_ID = '80cd9dd2-17a3-4abc-9fc9-db3c06f015fa';
        const shouldHide = survey?.projectIds?.some(
            (p: any) => p?.id === METRO_MEDELLIN_PROJECT_ID || p === METRO_MEDELLIN_PROJECT_ID
        );
        if (shouldHide) {
            document.body.classList.add('hide-recaptcha-badge');
        } else {
            document.body.classList.remove('hide-recaptcha-badge');
        }
        return () => {
            document.body.classList.remove('hide-recaptcha-badge');
        };
    }, [survey]);

    return isPrevisora ? (
        <>
            <Box
                sx={{
                    width: '100%',
                    maxWidth: '1200px',
                    margin: '0 auto',
                    overflow: 'hidden',
                    borderBottomLeftRadius: '40% 8%',
                    borderBottomRightRadius: '40% 8%',
                }}
            >
                <Box
                    component="img"
                    src={survey.logo}
                    alt="Encuesta Previsora"
                    sx={{
                        width: '100%',
                        height: 'auto',
                        display: 'block',
                        objectFit: 'contain',
                    }}
                />
            </Box>
            {!save && (
                <FormRenderTemporalPrevisora
                    onChangeSurvey={(survey) => setSurvey(survey)}
                    onSave={() => setSave(true)}
                />
            )}
            {save && (
                <Box
                    sx={{
                        p: 4,
                        textAlign: 'center',
                        color: '#800080',
                        fontFamily: 'Lucida Sans',
                        lineHeight: 1.8,
                        fontSize: '16px',
                    }}
                >
                    <Typography
                        sx={{
                            whiteSpace: 'pre-line',
                            textAlign: 'center',
                            fontFamily: 'Lucida Sans',
                            fontSize: { xs: '1.25rem', sm: '1.5rem', md: '1.875rem' },
                            px: { xs: 2, sm: 4 },
                            py: { xs: 4, sm: 8 },
                        }}
                    >
                        Has finalizado el proceso de calificación de las áreas
                        con las que interactuaste
                        <br />
                        <br />
                        ¡Gracias por tu activa participación!
                    </Typography>
                </Box>
            )}
        </>
    ) : survey?.headerImage && !survey?.withTemplate ? (
        <>
            <Box
                sx={{
                    width: '100%',
                    overflow: 'hidden',
                }}
            >
                <Box
                    component="img"
                    src={survey.headerImage}
                    alt="Encabezado"
                    sx={{
                        width: '100%',
                        height: 'auto',
                        display: 'block',
                        maxHeight: {
                            xs: '220px',
                            sm: '350px',
                            md: `${survey?.headerImageHeight || '560'}px`,
                        },
                        objectFit: 'cover',
                        objectPosition: 'center',
                    }}
                />
            </Box>
            {!save && (
                <Box
                    sx={{
                        textAlign: 'center',
                        p: { xs: 1, md: 2 },
                    }}
                >
                    <Typography
                        fontWeight="bold"
                        fontSize={{ xs: '2.2rem', md: '3rem' }}
                        sx={{
                            color: dominantColor,
                            fontFamily: fontFamily || 'inherit',
                        }}
                    >
                        {survey?.title}
                    </Typography>
                    {survey?.description && (
                        <Typography
                            fontSize={{ xs: '0.95rem', md: '1.1rem' }}
                            sx={{
                                color: dominantColor,
                                mt: 1,
                                fontFamily: fontFamily || 'inherit',
                            }}
                        >
                            {survey?.description}
                        </Typography>
                    )}
                </Box>
            )}

            {!save && (
                <FormRender
                    onChangeSurvey={(survey) => setSurvey(survey)}
                    onSave={() => setSave(true)}
                    dominantColor={dominantColor}
                    fontFamily={fontFamily}
                />
            )}
            {save && (
                <Box
                    sx={{
                        p: 4,
                        textAlign: 'center',
                        color: dominantColor,
                        fontFamily: 'Lucida Sans',
                        lineHeight: 1.8,
                        fontSize: '16px',
                    }}
                >
                    <Typography
                        sx={{
                            whiteSpace: 'pre-line',
                            textAlign: 'center',
                            fontFamily: 'Lucida Sans',
                            fontSize: { xs: '2rem', sm: '3rem', md: '5rem' },
                            px: { xs: 2, sm: 4 },
                            py: { xs: 4, sm: 8 },
                        }}
                    >
                        ¡Gracias por tu colaboración!
                    </Typography>
                </Box>
            )}
        </>
    ) : survey?.withTemplate ? (
        <SurveyLayout
            title={save ? '¡Gracias por tu colaboración!' : survey?.title}
            description={save ? '' : survey?.description}
            logo={survey?.logo}
            color={dominantColor}
            fontFamily={fontFamily}
        >
            {!save && (
                <FormRender
                    onChangeSurvey={(survey) => setSurvey(survey)}
                    onSave={() => setSave(true)}
                    dominantColor={dominantColor}
                    fontFamily={fontFamily}
                />
            )}
        </SurveyLayout>
    ) : !save ? (
        <Box px={{ xs: '20px', lg: 0 }}>
            <Typography
                fontFamily={fontFamily || 'Lucida Sans'}
                fontSize="2rem"
                fontWeight="700!important"
                textAlign="center"
                color={dominantColor}
            >
                {survey?.title || ''}
            </Typography>
            <FormRender
                onChangeSurvey={(survey) => setSurvey(survey)}
                onSave={() => setSave(true)}
                dominantColor={dominantColor}
            />
        </Box>
    ) : (
        <Box
            sx={{
                p: 4,
                textAlign: 'center',
                color: '#800080',
                fontFamily: 'Lucida Sans',
                lineHeight: 1.8,
                fontSize: '16px',
            }}
        >
            <Typography
                sx={{
                    whiteSpace: 'pre-line',
                    textAlign: 'center',
                    fontFamily: 'Lucida Sans',
                    fontSize: { xs: '1.25rem', sm: '1.5rem', md: '1.875rem' },
                    px: { xs: 2, sm: 4 },
                    py: { xs: 4, sm: 8 },
                }}
            >
                Has finalizado el proceso de calificación de las áreas con las
                que interactuaste
                <br />
                <br />
                ¡Gracias por tu activa participación!
            </Typography>
        </Box>
    );
};

export default SurveysFormView;
